export const largeLabelProps = {
    style: {
        fontSize: "1.2rem",
        marginTop: "-0.7rem",
        paddingBottom: "0.5rem",
    },
    shrink: true,
};